import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './login.css';
import url from '../../server_url';

const STEP_PHRASE = 'phrase';
const STEP_PASSWORD = 'password';
const STEP_DONE = 'done';

export default function ResetPassword() {
  const navigate = useNavigate();
  const [step, setStep] = useState(STEP_PHRASE);
  const [email, setEmail] = useState('');
  const [phrase, setPhrase] = useState('');
  const [resetToken, setResetToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const wordCount = phrase
    .trim()
    .split(/[\s-]+/)
    .filter(Boolean).length;

  const verifyPhrase = () => {
    setError('');
    if (!email.trim()) {
      setError('Enter the email address on the account.');
      return;
    }
    if (wordCount !== 12) {
      setError(
        `Your security phrase is 12 words. You have entered ${wordCount}.`
      );
      return;
    }
    setBusy(true);
    axios
      .post(`${url}/api/v2/auth/forgot-password/verify-phrase`, {
        email: email.trim(),
        phrase: phrase.trim()
      })
      .then((res) => {
        setResetToken(res.data.resetToken);
        setStep(STEP_PASSWORD);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            'Could not verify that phrase. Please try again.'
        );
      })
      .finally(() => setBusy(false));
  };

  const submitPassword = () => {
    setError('');
    if (newPassword.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    setBusy(true);
    axios
      .post(`${url}/api/v2/auth/reset-password-with-phrase`, {
        resetToken,
        newPassword
      })
      .then(() => setStep(STEP_DONE))
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            'Could not reset your password. Please try again.'
        );
      })
      .finally(() => setBusy(false));
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '80vh',
        background: 'linear-gradient(to right, #1F2834 50%, #12181F 50%)',
        position: 'relative'
      }}
    >
      <img
        src={require('../../Assets/leftring.png')}
        alt=""
        style={{
          width: window.innerWidth < 700 ? '200px' : '300px',
          position: 'absolute',
          bottom: 0,
          left: 0
        }}
      />

      <div className="login-card">
        <h3 style={{ color: 'white', textAlign: 'left', width: '80%' }}>
          Reset Your Password
        </h3>

        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          {step === STEP_PHRASE && (
            <>
              <p style={{ color: 'gray', fontSize: '12px' }}>
                Enter your account email and the 12-word security phrase from
                your <code>pn_phrases.txt</code> download.
              </p>

              <label>Email ID</label>
              <input
                required
                type="email"
                placeholder="Email ID"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <label>Security Phrase</label>
              <textarea
                required
                rows={3}
                placeholder="Moonlight-Harmony-Seashell-..."
                value={phrase}
                onChange={(e) => setPhrase(e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  borderRadius: '5px',
                  border: 'none',
                  outline: 'none',
                  fontFamily: 'inherit',
                  fontSize: '0.9rem',
                  boxSizing: 'border-box',
                  resize: 'vertical'
                }}
              />
              <span
                style={{
                  fontSize: '12px',
                  color: wordCount === 12 ? '#4caf50' : 'gray'
                }}
              >
                {wordCount} / 12 words
              </span>

              <button
                type="submit"
                className="primary signUpbtn"
                disabled={busy}
                onClick={verifyPhrase}
              >
                {busy ? 'Verifying...' : 'Verify Phrase'}
              </button>
            </>
          )}

          {step === STEP_PASSWORD && (
            <>
              <p style={{ color: 'gray', fontSize: '12px' }}>
                Phrase verified. Choose a new password within the next 10
                minutes.
              </p>

              <label>New Password</label>
              <input
                required
                type="password"
                placeholder="At least 8 characters"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />

              <label>Confirm Password</label>
              <input
                required
                type="password"
                placeholder="Re-enter new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />

              <button
                type="submit"
                className="primary signUpbtn"
                disabled={busy}
                onClick={submitPassword}
              >
                {busy ? 'Saving...' : 'Set New Password'}
              </button>
            </>
          )}

          {step === STEP_DONE && (
            <>
              <p style={{ color: '#4caf50', fontSize: '14px' }}>
                Password changed. You can now log in with your new password.
              </p>
              <button
                type="button"
                className="primary signUpbtn"
                onClick={() => navigate('/login')}
              >
                Back to Login
              </button>
            </>
          )}

          {error ? (
            <p style={{ color: '#ff6b6b', fontSize: '13px' }}>{error}</p>
          ) : null}

          {step !== STEP_DONE && (
            <div className="extra-info" style={{ marginTop: '0.5rem' }}>
              <span onClick={() => navigate('/login')}>Back to Login</span>
            </div>
          )}

          <p style={{ color: '#C2C2C2', fontSize: '12px' }}>
            Your security phrase was issued when your wallet was created. It is
            the only way to recover access if you lose your password.
          </p>
        </form>
      </div>
    </div>
  );
}
